module.exports = __webpack_public_path__ + "img/dengwei-h5-clean.90124d26.png";